import { NgClass, NgFor, NgIf } from '@angular/common';
import {
    Component,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DavesaDrawerComponent } from '@davesa/components/drawer';
import { DavesaScrollbarDirective } from '@davesa/directives/scrollbar';
import { Subject, takeUntil } from 'rxjs';

interface SupportLink {
    icon: string;
    title: string;
    url: string;
}

@Component({
    selector: 'support-links',
    templateUrl: './support-links.component.html',
    styleUrls: ['./support-links.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'supportLinks',
    imports: [
        NgClass,
        NgFor,
        NgIf,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        DavesaDrawerComponent,
        DavesaScrollbarDirective,
    ],
})
export class SupportLinksComponent implements OnDestroy {
    @ViewChild('supportLinksDrawer') supportLinksDrawer!: DavesaDrawerComponent;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    supportLinks: SupportLink[] = [
        {
            icon: 'heroicons_outline:document-plus',
            title: 'New Study Build',
            url: 'https://davesa-team.atlassian.net/jira/core/form/f304f4f3-1062-4215-92c7-80a5f68bd8e1',
        },
        {
            icon: 'heroicons_outline:pencil-square',
            title: 'Update Existing Study',
            url: 'https://davesa-team.atlassian.net/jira/core/form/51dc1c9c-6795-45b1-b9a5-d203119ebffd',
        },
        {
            icon: 'heroicons_outline:light-bulb',
            title: 'Enhancement Suggestions',
            url: 'https://davesa-team.atlassian.net/jira/core/form/947f7438-a008-4483-9e27-e9363e4522ff',
        },
        {
            icon: 'heroicons_outline:user-plus',
            title: 'External User Access',
            url: 'https://davesa-team.atlassian.net/jira/core/form/f1530025-ad39-41cb-847d-b9a008888eab',
        },
        {
            icon: 'heroicons_outline:presentation-chart-line',
            title: 'Demo Request',
            url: 'https://davesa.com/schedule-a-demo',
        },
        {
            icon: 'heroicons_outline:question-mark-circle',
            title: 'General Questions',
            url: 'https://davesa-team.atlassian.net/jira/core/form/3bf50b0f-a533-49b9-8fc1-b0951aa46f33',
        },
    ];

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open a support link in a new tab
     *
     * @param url
     */
    openSupportLink(url: string): void {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: SupportLink): string {
        return item.url;
    }
}
